<template>
  <transition
    enter-active-class="transition-opacity duration-300 ease-out"
    leave-active-class="transition-opacity duration-300 ease-in"
  >
    <div
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto p-4"
    >
      <!-- these are to precompile the expected widths -->
      <!-- w-[600px] w-[800px] -->
      <div :class="`bg-white rounded-lg shadow-lg p-6 relative my-auto max-w-full w-[${width}]`">
        <button class="absolute top-2 right-2 text-gray-400" @click="$emit('close')">
          &#x2715;
        </button>
        <div class="mb-4">
          <h2 class="text-xl font-semibold">{{ title }}</h2>
        </div>
        <div>
          <slot></slot>
          <div v-if="showActions" class="flex justify-end mt-4">
            <button class="bg-gray-500 text-white py-2 px-4 rounded mr-2" @click="$emit('close')">
              {{ closeLabel }}
            </button>
            <button
              class="bg-green-600 text-white py-2 px-4 rounded disabled:opacity-40"
              @click="$emit('submit')"
              v-if="submit"
              :disabled="disabled || loading"
            >
              <div class="flex items-center gap-2">
                <div v-if="loading"><Spinner class="w-4 h-4" /></div>
                <div>{{ label }}</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import Spinner from './Spinner.vue'

defineEmits(['close', 'submit'])

defineProps({
  title: String,
  showActions: { type: Boolean, required: false, default: true },
  width: { type: String, default: '600px' },
  disabled: { type: Boolean, required: false, default: false },
  label: { type: String, default: 'Opslaan' },
  closeLabel: { type: String, default: 'Sluiten' },
  submit: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})
</script>
